import { createContext, useContext, useEffect, useState } from "react";
const K = "onelook_wishlist_v1";
const Ctx = createContext();
export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => { try { return JSON.parse(localStorage.getItem(K)) || []; } catch { return []; } });
  useEffect(() => { localStorage.setItem(K, JSON.stringify(ids)); }, [ids]);
  const toggle = (id) => setIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const has = (id) => ids.includes(id);
  return <Ctx.Provider value={{ ids, toggle, has }}>{children}</Ctx.Provider>;
}
export const useWishlist = () => useContext(Ctx);
